// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pg-1";
export var stateContainer = "_pg-0";